/**
 * Shared ZARC types — sem decorators TypeORM, seguro para importar no frontend.
 */

/** Tipo de chave da API ZARC */
export enum ZarcApiKeyType {
  FREE = 'FREE',
  PAID = 'PAID',
}

// ── RF005 ────────────────────────────────────────────────────────────────────

/**
 * Crop cycle group (cicloculti) as sent by SRC.
 *
 * Canonical form: uppercase, no parentheses, no accents — alinhado com API Embrapa.
 * A SRC pode enviar em qualquer capitalização; o app normaliza antes de comparar/persistir.
 * RN003: domínio permitido.
 */
export enum CropCycleGroup {
  GRUPO_I = 'GRUPO I',
  GRUPO_II = 'GRUPO II',
  GRUPO_III = 'GRUPO III',
  GRUPO_IV = 'GRUPO IV',
  GRUPO_V = 'GRUPO V',
  PERENE = 'PERENE',
}

/**
 * Soil type (tipo_solo) as sent by SRC.
 *
 * Canonical form: uppercase, sem acentuação — alinhado com API Embrapa / banco ZarcZoning.
 * A SRC pode enviar com ou sem acento; o app normaliza antes de comparar/persistir.
 * RN003: domínio permitido.
 */
export enum SoilType {
  ARENOSO = 'ARENOSO',
  TEXTURA_MEDIA = 'TEXTURA MEDIA',
  ARGILOSO = 'ARGILOSO',
  AD1 = 'AD1',
  AD2 = 'AD2',
  AD3 = 'AD3',
  AD4 = 'AD4',
  AD5 = 'AD5',
  AD6 = 'AD6',
}


